import React, { useState } from 'react';

import { PersonAddRounded } from '@mui/icons-material';

import Button, { ButtonProps } from '../../../components/Button';
import ShareModal from '../../../components/ShareModal';
import {
  useGetNotesUsersQuery, useShareNotesMutation, useUnshareNotesMutation,
} from '../../../services/notes';
import useUsersQuery from '../../../utils/react/hooks/useUsersQuery';

interface ShareButtonProps extends ButtonProps {
  targetTitle: string,
  subject: string,
  category?: string,
  noteKey?: string,
  hideIcon?: boolean
}

const ShareButton = ({
  targetTitle, subject, category, noteKey, hideIcon, ...rest
}: ShareButtonProps) => {
  const [search, setSearch] = useState<string>('');
  const [shareModalOpen, setShareModalOpen] = useState<boolean>(false);

  const { data: searchRes, isFetching: isSearchResFetching } = useUsersQuery(
    { search }, { skip: search === '' || !shareModalOpen },
  );

  const { data: notesUsersData } = useGetNotesUsersQuery({
    subject, category, noteKey,
  }, { skip: !subject || !shareModalOpen });
  const [shareNotes, {
    error: shareError, isLoading: isShareLoading,
  }] = useShareNotesMutation();
  const [unshareNotes, {
    error: unshareError, isLoading: isUnshareLoading,
  }] = useUnshareNotesMutation();

  return (
    <>
      <Button
        size="medium"
        startIcon={hideIcon ? undefined : <PersonAddRounded />}
        {...rest}
        onClick={async (e) => {
          if (rest.onClick) await rest.onClick(e);
          setShareModalOpen(true);
        }}
      >
        Share
      </Button>
      <ShareModal
        subject={targetTitle}
        open={shareModalOpen}
        handleClose={() => setShareModalOpen(false)}
        searchUsers={(searchRes || []).filter((x) => !(notesUsersData?.data || [])
          .map((u) => u.value).includes(x?.id))}
        isSearchFetching={isSearchResFetching}
        users={(notesUsersData?.data || [])}
        search={(str) => setSearch(str)}
        share={(userId) => shareNotes({
          userId, subject, category, noteKey,
        })}
        unshare={(userId) => unshareNotes({
          userId, subject, category, noteKey,
        })}
        isUnshareLoading={isUnshareLoading}
        isShareLoading={isShareLoading}
        error={shareError || unshareError}
      />
    </>
  );
};

export default ShareButton;
